const topics = [
  { label: '#庆余年2大结局', heat: '128万讨论' },
  { label: '#繁花沪语版', heat: '96万讨论' },
  { label: '#长相思2虐心', heat: '85万讨论' },
  { label: '#唐朝诡事录探案', heat: '73万讨论' },
  { label: '#狂飙名场面', heat: '68万讨论' },
  { label: '#三体特效解析', heat: '59万讨论' },
  { label: '#甄嬛传十级学者', heat: '52万讨论' },
  { label: '#今年最值得追的剧', heat: '47万讨论' },
  { label: '#国产剧文艺复兴', heat: '41万讨论' },
];

export default function TopicsSection() {
  return (
    <section id="topics" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="text-center mb-10">
          <span className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-secondary-500/10 border border-secondary-500/20 mb-4">
            <i className="ri-hashtag text-secondary-500 text-sm"></i>
            <span className="text-secondary-400 text-xs font-medium">热门话题</span>
          </span>
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">剧迷热议话题</h2>
          <p className="text-foreground-500 text-sm mt-3 max-w-xl mx-auto">
            全网剧迷都在讨论的热门话题，加入讨论分享你的观点
          </p>
        </div>

        <div className="flex flex-wrap justify-center gap-3 max-w-4xl mx-auto">
          {topics.map((topic, i) => (
            <div
              key={i}
              className="group bg-background-50 border border-background-200/60 rounded-full px-5 py-2.5 hover:border-primary-500/30 hover:bg-primary-500/5 transition-all cursor-pointer flex items-center gap-3"
            >
              <span className="text-foreground-700 group-hover:text-primary-500 text-sm font-medium transition-colors">
                {topic.label}
              </span>
              <span className="text-foreground-400 text-xs bg-background-200 px-2 py-0.5 rounded-full">
                {topic.heat}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}